export default __webpack_public_path__ + "static/media/S-036.65043635.png";